<template>
  <div class="content-editor">
    <div v-for="t of tagsRef" :key="t.id">
      <ContentItem :content-id="t.contentId" :content-tag-id="t.id" />
    </div>
    <!-- <DragDrop :uppy="uppy" /> -->
  </div>
</template>

<style lang="scss" scoped>
// @import '@uppy/core/dist/style.css';
// @import '@uppy/drag-drop/dist/style.css';

.content-editor {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

</style>

<script lang="ts" setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { Content, ContentTag, ItemType } from '@/rd/ResearchDataModel'
import { useContentStore } from '@/rd/ContentStore'
import { useContentTagStore } from '@/rd/ContentTagStore'
import { LoadMode } from '@/util/AsyncData'
import ContentItem from './ContentItem.vue'
import { Environment } from '@/util/Environment'
import { useTokenManager } from '@/auth/TokenManager'
import { CompositeId } from '@/rd/CompositeId'
import { DateTime } from 'luxon'
import { AsyncUtil } from '@/util/AsyncUtil'

const props = defineProps<{
  itemType: ItemType
  itemId?: string
}>()

const contentStore = useContentStore()
const contentTagStore = useContentTagStore()
const tokenManager = useTokenManager()

const tagsRef = computed(() => contentTagStore.getTagsForItems(props.itemType, [props.itemId], LoadMode.EnsureLoaded))

// onMounted(() => {
//   uppy.on('file-added', async (file) => {
//     try {
//       const groupId = CompositeId.getGroupId(props.itemId)!
//       const newContent = new Content()
//       newContent.fileName = file.name
//       newContent.dataModifiedDate = DateTime.utc()
//       const contentId = await contentStore.addAsync(groupId, newContent)
//       console.log(`ContentEditor: content ${contentId} created`)

//       const uploadUrl = `${Environment.get('RESEARCH_DATA_URL')}content/${contentId}/data?size=${file.data.size}`
//       const xhrPlugin = uppy.getPlugin('XHRUpload')
//       xhrPlugin?.setOptions({
//         endpoint: uploadUrl,
//       })
//       console.log(`ContentEditor: content upload url: ${uploadUrl}`)

//       await uppy.upload()
//       console.log(`Content ${contentId} upload succeeded: ${file.name}`)

//       // TODO: wait for server notification when content processing completed?
//       contentStore.trackAsyncContents([contentId], LoadMode.Reload)

//       const newTag = new ContentTag()
//       newTag.contentId = contentId
//       newTag.itemType = props.itemType
//       newTag.itemId = props.itemId
//       const tagId = await contentTagStore.addAsync(newTag)
//     }
//     catch (error) {
//       console.log(`ContentEditor: Error uploading file ${file.name}`, error)
//       uppy.removeFile(file.id)
//     }
//   })
// })

// onBeforeUnmount(() => {
//   uppy.destroy()
// })

// function onBeforeUpload(xhr: XMLHttpRequest) {
//   xhr.setRequestHeader('Authorization', `Bearer ${tokenManager.current.token}`)
// }

// function onAfterUpload(xhr: XMLHttpRequest) {
//   return {} // empty response
// }
</script>
